export default [
    {
        path: '/_table',
        name: 'table|home',
        component: () => import('@/views/table/index.vue'),
        meta: {
          layout: 'full',
        }
      },
]